import { WidgetsTypeEnum } from "src/app/enums/widgets/widgets-type.enum";
import { WidgetsContainerAbstract } from "src/app/abstract/widgets/widgets-container.abstract";
import { WidgetsAbstract } from "src/app/abstract/widgets/widgets.abstract";

export class WidgetsArrayModel extends WidgetsContainerAbstract {
    readonly icon: string = 'data_array';
    name: string = 'Array';
    readonly widgetType: WidgetsTypeEnum = WidgetsTypeEnum.ARRAY;
    template = '';
    readonly badge: string = '[';
    readonly placeholderClassName: string = 'array-placeholder';
    children: WidgetsAbstract[] = [];

    toJSON() : any {
        return { 
            badge: this.badge,
            widgetType: this.widgetType,
            id: this.id,
            parentId: this.parentId ? this.parentId : undefined,
            name: this.name,            
            children: this.children 
        };
    }
    
    cloneFrom(origin: WidgetsArrayModel) : WidgetsArrayModel {
        this.name = origin.name;        
        if (origin.template) {
            this.template = origin.template;
        }        
        return this;
    }    
}
